export default __webpack_public_path__ + "static/media/Roboto-Regular.d08b3cc8.ttf";